const PageLoading = ({ pageLoadingMsg }) => {
  return (
    <div className={"loader"}>
      <div
        style={{ background: "none" }}
        className={"prtitle w-100 h-100"}
      >
        <div style={{}} className="spinner-grow" />
        {pageLoadingMsg && pageLoadingMsg}
        <br />
        and wait until the process is completed.
      </div>
    </div>
  );
};

export default PageLoading;
